// @flow
import React, { type Node, type Element, type ComponentType, type ChildrenArray, useCallback } from 'react';

import PlainDropdownSurface, { SurfaceType } from '../plain-dropdown-surface';
import PlainIcon, { iconTypes, colorTypes } from '../plain-icon';
import PlainList from '../plain-list';

import styles from './plain-item-picker.module.scss';;


type ChildrenItemProps = { id: string, ... }

export type PlainItemPickerProps<T: ChildrenItemProps> = {
  className?: string,
  children: ChildrenArray<Element<ComponentType<T>>>,
  closeOnClick?: boolean,
  onItemClick?: (targetProps: ChildrenItemProps) => void,
}

function PlainItemPicker<T: ChildrenItemProps>({
  className,
  children,
  closeOnClick = true,
  onItemClick,
}: PlainItemPickerProps<T>): Node {
  const itemClick = useCallback((toggle: () => void) => (targetProps: ChildrenItemProps) => {
    if (onItemClick) {
      onItemClick(targetProps);
    }
    if (closeOnClick) {
      toggle();
    }
  }, [onItemClick, closeOnClick]);

  const renderItems = useCallback((toggle: () => void) => (
    <PlainList id="items" onClick={itemClick(toggle)}>
      {children}
    </PlainList>
  ), [children, itemClick]);

  return (
    <PlainDropdownSurface
      id="items_surface"
      type={SurfaceType.Listbox}
      surfaceContent={renderItems}
      className={className}
    >
      {(onOpenClose, opened, areaProps) => (
        <button
          type="button"
          onClick={onOpenClose}
          className={styles.button}
          {...areaProps}
        >
          <PlainIcon
            type={iconTypes.CALENDAR}
            colorType={opened ? colorTypes.COLOR_PRIMARY : colorTypes.COLOR_GRAY}
            width={18}
            height="auto"
          />
        </button>
      )}
    </PlainDropdownSurface>
  );
}

export default PlainItemPicker;
